const baseUrl = '/transactions';
export const transactionRoutes = {
  checkPayment: "".concat(baseUrl, "/check-payment"),
  credit: "".concat(baseUrl, "/credit"),
  customCharge: "".concat(baseUrl, "/custom-charge"),
  bulkCustomCharge: "".concat(baseUrl, "/bulk-custom-charge"),
  customCredit: "".concat(baseUrl, "/custom-credit"),
  refund: "".concat(baseUrl, "/refund"),
  scheduledCustomTransaction: "".concat(baseUrl, "/scheduled-custom-transaction"),
  scheduledCustomTransactionById: id => "".concat(baseUrl, "/scheduled-custom-transaction/").concat(id),
  scheduledCustomTransactionByIdStatus: id => "".concat(baseUrl, "/scheduled-custom-transaction/").concat(id, "/status"),
  verifyPayment: "".concat(baseUrl, "/verify-check-payment"),
  void: "".concat(baseUrl, "/void"),
  customTransactions: "".concat(baseUrl, "/custom-transactions")
};